import React from 'react'

import Navbar from './navbar'

const Header = () => {
    return (

        <header>
            <div className="navbar-div">
                <Navbar /> 
            </div>



        </header>
    )
}

export default Header